export default "<h1>Beispiel für Anmeldung:</h1>\n\n<p-card>\n  <app-login-form></app-login-form>\n</p-card>\n"